import script from "./AttachmentList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttachmentList.vue?vue&type=script&setup=true&lang=ts"

import "./AttachmentList.vue?vue&type=style&index=0&id=301b513a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-301b513a"]])

export default __exports__